import withQueryParams from "../../utils/withQueryParams";
import getUserCacheKey from "../../utils/getUserCacheKey";
import productPageBaseUri from "../../utils/productPageBaseUri";

class SparePartsServiceClient {
  constructor(integrationService) {
    this._integrationService = integrationService;
  }

  fetchSpareParts = async (productCode) => {
    const sparePartsUri = withQueryParams(`${productPageBaseUri}api/products/${productCode}/spareParts`, {cacheKey: getUserCacheKey()});

    return this._integrationService.read({
      url: sparePartsUri,
      method: "GET",
      credentials: "include"
    });
  }
}

export default SparePartsServiceClient;
